import { Logger } from '@/utils/logger';
import { useLayoutEffect } from 'react';
import useCustomer from './user/useCustomer';

const logger = new Logger('usePersistIsExternal');

export const IS_EXTERNAL_PERSIST_KEY = 'IS_EXTERNAL';

export const getPersistedIsExternal = () => {
  const localStorageIsExternal = localStorage.getItem(IS_EXTERNAL_PERSIST_KEY);

  logger.info('getPersistedIsExternal', {
    localStorageIsExternal,
  });

  return localStorageIsExternal;
};

/**
 * Persists customer isExternal value across login sessions to allow for redirection to the correct login page origin (on the patient or the customer portal)
 */
export function usePersistIsExternal() {
  const { data: customer } = useCustomer();

  useLayoutEffect(() => {
    if (customer) {
      localStorage.setItem(IS_EXTERNAL_PERSIST_KEY, `${customer.isExternal}`);

      logger.info('useLayoutEffect', {
        'customer.isExternal': customer.isExternal,
      });
    }
  }, [customer]);
}
